import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-124" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-125" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Take a Look Inside Your Teaching System" body="Real pages. Practical techniques. Ready-to-use teaching resources." data-id="element-126" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-127" data-mp="235lydeb6w8tb">
          <InsidePagesCarousel data-id="element-128" data-mp="235c7loiblxmk" />
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-body text-[13px] text-brand-charcoal/60" data-id="element-129" data-mp="1y70yjfzunr5e">
          Preview real materials included in the digital collection. Tap any page to enlarge it.
        </p>
      </div>
    </section>;
}